"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.listParts = void 0;
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
const utils_1 = require("@aws-amplify/core/internals/utils");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const utils_2 = require("../utils");
const base_1 = require("./base");
const listPartsSerializer = async (input, endpoint) => {
    const headers = {};
    const url = new utils_1.AmplifyUrl(endpoint.url.toString());
    (0, utils_2.validateS3RequiredParameter)(!!input.Key, 'Key');
    url.pathname = (0, utils_2.serializePathnameObjectKey)(url, input.Key);
    (0, utils_2.validateS3RequiredParameter)(!!input.UploadId, 'UploadId');
    url.search = new utils_1.AmplifyUrlSearchParams({
        'x-id': 'ListParts',
        uploadId: input.UploadId,
    }).toString();
    return {
        method: 'GET',
        headers,
        url,
    };
};
const listPartsDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        // error is always set when statusCode >= 300
        throw (0, utils_2.buildStorageServiceError)((await (0, base_1.parseXmlError)(response)));
    }
    else {
        const parsed = await (0, utils_2.parseXmlBody)(response);
        const contents = (0, utils_2.map)(parsed, {
            UploadId: 'UploadId',
            Parts: [
                'Part',
                value => (0, utils_2.emptyArrayGuard)(value, utils_2.deserializeCompletedPartList),
            ],
        });
        return {
            $metadata: (0, aws_client_utils_1.parseMetadata)(response),
            ...contents,
        };
    }
};
exports.listParts = (0, composers_1.composeServiceApi)(utils_2.s3TransferHandler, listPartsSerializer, listPartsDeserializer, { ...base_1.defaultConfig, responseType: 'text' });
